import { transformNullIntoEmpty } from './../../utils/DataUtils';
import {
  CHANGE_PROFESSOR_STATUS_ACTION,
  CHANGED_PROFESSOR_EDITING_VALUE_ACTION,
  CLEARED_PROFESSOR_ACTION,
  CLEARED_PROFESSORES_ACTION,
  CLEARED_PROFESSORES_PAGE_ACTION,
  LOADED_PROFESSOR_ACTION,
  LOADED_PROFESSORES_ACTION,
  LOADED_PROFESSORES_PAGE_ACTION,
  LOADING_PROFESSORES_LIST,
  RESETED_PROFESSORES,
  REMOVING_PROFESSOR_ACTION,
  LOADING_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
  LOEADED_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
  CLEARED_ALL_PROFESSOR_GESTOR_BY_ESCOLA,
  CLEARED_EDUCADORES_ACTION,
  LOADING_EDUCADORES_LIST,
  LOADED_EDUCADORES_ACTION,
  SET_NAME,
} from './ProfessoresActions';
import { TOTAL_ITEMS_FOR_PAGE } from '../../utils/PaginationUtils';
import {
  ARRAY_UTILS_SORT_ASC,
  getOrderedByObjectStringProperty,
} from '../../utils/ArrayUtils';
import { CLEAR_NAME_ACTION } from './AssessoresActions';

const PAGE_LIST_INITIAL_STATE = {
  busca: '',
  page: -1,
  totalElements: 0,
  totalPages: 0,
  elements: [],
};

const PROFESSOR_EDITING_NOT_NULL_PROPS = [
  'nome',
  'celular',
  'email',
  'mae',
  'dataNascimento',
  'rg',
  'cpf',
  'cidade',
];

const PROFESSOR_EDITING_INITIAL_STATE = {
  nome: '',
  celular: '',
  email: '',
  mae: '',
  dataNascimento: '',
  rg: '',
  cpf: '',
  cidade: '',
  escolas: [],
};

const INITIAL_STATE = {
  list: [],
  loadingList: false,

  educadoresList: [],
  loadingEducadoresList: false,
  pageSize: TOTAL_ITEMS_FOR_PAGE,
  pageList: PAGE_LIST_INITIAL_STATE,
  professorEditing: PROFESSOR_EDITING_INITIAL_STATE,
  removingProfessor: false,
  loadingProfessorGestorByEscola: false,
  professoresGestoresByEscola: [],
  professorName: null,
  cordenadorName: null,
  assessorName: null,
};

const getRefreshedPageList = (lastPageList, newPageList) => {
  return {
    ...lastPageList,
    busca: newPageList.busca,
    page: newPageList.page,
    totalElements: newPageList.totalElements,
    totalPages: newPageList.totalPages,
    elements: [...lastPageList.elements, ...newPageList.elements],
  };
};

const getChangedStatusList = (pageList, cpf, status) => {
  let newPageList = {
    ...pageList,
    elements: [],
  };
  pageList.elements.map((element, index) => {
    if (element.cpf === cpf) {
      newPageList.elements.push({
        ...element,
        status,
      });
    } else {
      newPageList.elements.push(element);
    }
    return index;
  });
  return newPageList;
};

export default function ProfessoresReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESETED_PROFESSORES:
      return {
        ...INITIAL_STATE,
      };
    case SET_NAME:
      if (action.payload.type === 'professorName') {
        return {
          ...state,
          professorName: action.payload.value,
          assessorName: null,
          cordenadorName: null,
        };
      } else if (action.payload.type === 'assessorName') {
        return {
          ...state,
          assessorName: action.payload.value,
          professorName: null,
          cordenadorName: null,
        };
      } else if (action.payload.type === 'cordenadorName') {
        return {
          ...state,
          cordenadorName: action.payload.value,
          professorName: null,
          assessorName: null,
        };
      }
      return state;
    case CLEAR_NAME_ACTION:
      return {
        ...state,
        assessorName: null,
        professorName: null,
        cordenadorName: null,
      };
    case CLEARED_PROFESSOR_ACTION:
      return { ...state, professorEditing: PROFESSOR_EDITING_INITIAL_STATE };
    case CLEARED_PROFESSORES_ACTION:
      return { ...state, list: [] };
    case LOADING_PROFESSORES_LIST:
      return { ...state, loadingList: action.payload };
    case LOADED_PROFESSORES_ACTION:
      return {
        ...state,
        list: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case CLEARED_EDUCADORES_ACTION:
      return { ...state, educadoresList: [] };
    case LOADING_EDUCADORES_LIST:
      return { ...state, loadingEducadoresList: action.payload };
    case LOADED_EDUCADORES_ACTION:
      return {
        ...state,
        educadoresList: getOrderedByObjectStringProperty(
          action.payload,
          'nome',
          ARRAY_UTILS_SORT_ASC
        ),
      };
    case LOADED_PROFESSOR_ACTION:
      return {
        ...state,
        professorEditing: transformNullIntoEmpty(
          action.payload,
          PROFESSOR_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADED_PROFESSORES_PAGE_ACTION:
      return {
        ...state,
        pageList: getRefreshedPageList(state.pageList, action.payload),
      };
    case CLEARED_PROFESSORES_PAGE_ACTION:
      return { ...state, pageList: PAGE_LIST_INITIAL_STATE };
    case CHANGED_PROFESSOR_EDITING_VALUE_ACTION:
      return {
        ...state,
        professorEditing: {
          ...state.professorEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case CHANGE_PROFESSOR_STATUS_ACTION:
      return {
        ...state,
        pageList: getChangedStatusList(
          state.pageList,
          action.payload.cpf,
          action.payload.status
        ),
      };
    case REMOVING_PROFESSOR_ACTION:
      return {
        ...state,
        removingProfessor: action.payload,
      };
    case CLEARED_ALL_PROFESSOR_GESTOR_BY_ESCOLA:
      return { ...state, professoresGestoresByEscola: [] };
    case LOADING_ALL_PROFESSOR_GESTOR_BY_ESCOLA:
      return { ...state, loadingProfessorGestorByEscola: action.payload };
    case LOEADED_ALL_PROFESSOR_GESTOR_BY_ESCOLA:
      return { ...state, professoresGestoresByEscola: action.payload };
    default:
      return state;
  }
}
